module.exports = __webpack_public_path__ + "static/img/03-banner3.334f2cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01-shouye/03-banner3.jpg
// module id = xJbo
// module chunks = 1